import React from "react";
import { Col } from "react-bootstrap";
import link from "../images/link-solid.svg";
import codeImg from "../images/code-solid.svg";

const ProjectCard = ({ title, description, imgUrl, url, code }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          <br />
          <span className="projects-link">
            <a href={url} className="projects-href">
              <img
                src={link}
                alt="Link"
                style={{
                  height: "16px",
                  width: "16px",
                  filter:
                    "invert(100%) sepia(100%) saturate(0%) hue-rotate(112deg) brightness(102%) contrast(103%)",
                }}
              />{" "}
              <h5>Preview</h5>
            </a>{" "}
            {code && (
              <>
                {" "}
                /
                <a href={code} className="projects-href">
                  <img
                    src={codeImg}
                    alt="Link"
                    style={{
                      height: "16px",
                      width: "16px",
                      filter:
                        "invert(100%) sepia(100%) saturate(0%) hue-rotate(112deg) brightness(102%) contrast(103%)",
                    }}
                  />{" "}
                  <h5>Code</h5>
                </a>
              </>
            )}
          </span>
        </div>
      </div>
    </Col>
  );
};

export default ProjectCard;
